import {
  request2,
  request1
} from './request';


//批量删除
export function deleteStudents(ids) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/DeleteStudentsAdmin',
    method: 'post',
    data: ids
  })
}
//修改密码
export function updatePassword(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdatePasswordAdmin',
    method: 'post',
    params: {
      id: obj.id,
      password: obj.password
    }
  })
}
//修改头像
export function updateAvatars(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdateAvatarsAdmin',
    method: 'post',
    params: {
      id: obj.id,
      avatarsUrl: obj.avatarsUrl
    }
  })
}
//修改身份证图片
export function updateIDCardImgInfo(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdateIdCardImgAdmin',
    method: 'post',
    params: {
      id: obj.id,
      frontProfileUrl: obj.frontProfileUrl,
      frontProfileToUrl: obj.frontProfileToUrl
    }
  })
}
//获取学生详情
export function GetStudentDetailInfo(id) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/StudentDetailInfo',
    method: 'get',
    params: {
      studentId: id
    }
  })
}

//获取学生头像
export function GetStudentAvatars(ids) {
  return request2({
    url: '/api2/TZsbStudentApi/StudentStudent/GetStudentAvatars',
    method: 'post',
    data: ids
  })
}
//获取学生身份证图片
export function GetIdCardImg(id) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/GetIdCardImg',
    method: 'post',
    params: {
      studentId: id
    }
  })
}



//获取学生属性分类列表
export function getStudentCategorys(type) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/Category/GetCategorytList',
    method: 'get',
    params: {
      type: type
    }
  })
}

//添加学生属性分类
export function addStudentCategory(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAttributeCategoryAdmin/CreateStudentAttributeCategory',
    method: 'post',
    data: {
      id: obj.id,
      name: obj.name,
      value: obj.value,
      parentId: obj.parentId,
      category: obj.category,
      remarks: obj.remarks
    }
  })
}

//删除学生属性分类
export function deleteStudentCategory(id) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAttributeCategoryAdmin/DelStudentAttributeCategory',
    method: 'post',
    params: {
      id: id
    }
  })
}

//编辑学生属性分类
export function editStudentCategory(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAttributeCategoryAdmin/UpdateStudentAttributeCategory',
    method: 'post',
    data: {
      id: obj.id,
      name: obj.name,
      value: obj.value,
      parentId: obj.parentId,
      category: obj.category,
      remarks: obj.remarks
    }
  })
}
// 获取学生集合-公共组件使用
export function getStudentCommonList(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/GetStudentCommonList',
    method: 'post',
    data: {
      name: obj.Name,
      selectStudentIds: obj.SelectStudentIds,
      total: obj.Total,
      handoverId: obj.handoverId,
      businessId: obj.businessId
    }
  })
}
export function GetStudentsByGradeId(obj) {
  let length2 = obj.studentIdList?.length || 0
  let idList = ''
  for (let i = 0; i < length2; i++) {
    if (i == length2 - 1) {
      idList += `studentIdList=${obj.studentIdList[i]}`
    } else {
      idList += `studentIdList=${obj.studentIdList[i]}&`
    }
  }
  return request2({
    url: `/api2/TZsbAdminTeachApi/GradeMemberDistribution/GetStudentsByGradeId?${idList}`,
    method: 'get',
    params: {
      name: obj.Name,
      id: obj.id,
      tel: obj.tel,
    }
  })
}
// 学员报名课程班级列表
export function GetOrderCourseList(obj) {
  return request2({
    url: '/api2/TZsbAdminFocuseApi/Orders/GetOrderCourseList',
    method: 'get',
    params: {
      StudentName: obj.StudentName,
      TelPhone: obj.TelPhone,
      CourseTitle: obj.CourseTitle,
      GradeName: obj.GradeName,
      ApplySchool: obj.ApplySchool,
      ApplyMajor: obj.ApplyMajor,
      PageIndex: obj.PageIndex,
      PageSize: obj.PageSize
    }
  })
}
// 查看指定学员报名课程及班级分配 /TZsbAdminFocuseApi/Orders/GetStudentCourseAndClassList  
export function GetStudentCourseAndClassList(id, bool, keyWord) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/Orders/GetStudentCourseAndClassList',
    method: 'get',
    params: {
      studentIds: id,
      isNoPay: bool,
      keyWord: keyWord,
    }
  })
}


//获取学员登录日志
export function GetLoginRecordList(obj, pageIndex, pageCount) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/LoginRecordAdmin/GetLoginRecordList',
    method: 'get',
    params: {
      StudentName: obj.studentName,
      IsOrder: obj.isOrder,
      StartTime: obj.startTime,
      EndTime: obj.endTime,
      TelNumber: obj.telNumber,
      PageIndex: pageIndex,
      PageSize: pageCount
    }
  })
}


// 通过Id集合获取学生信息 web端，无需登录request1
export function GetStudentListByIds(ids) {
  return request1({
    url: '/api2/TZsbWebStudentApi/StudentWeb/GetStudentInfoWeb',
    method: 'post',
    data: ids
  })
}

/**
 * @MyTeachingStudent 我的教学学员
 */
export function GetStudentsPage(obj, studentIds = []) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/EducationalStudentAdmin/GetStudentsPage`,
    method: 'post',
    data: {
      studentIds: studentIds,
      studentName: obj.studentName,
      tel: obj.tel,
      businessId: obj.businessId,
      state: obj.state,
      grade: obj.grade,
      openCourseStartTime: obj.openCourseStartTime,
      openCourseEndTime: obj.openCourseEndTime,
      graduatedSchool: obj.graduatedSchool,
      graduatedMajor: obj.graduatedMajor,
      applySchool: obj.applySchool,
      applyMajor: obj.applyMajor,
      studentSchoolAreaId: obj.studentSchoolAreaId,
      pageIndex: obj.pageIndex,
      pageSize: obj.pageSize
    }
  })
}
// 获取学员拉下数据/TZsbAdminStudentApi/BusinessStudentAdmin/GetBusinessStudentSelectData
export function GetBusinessStudentSelectData(obj, pageIndex, pageCount) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/BusinessStudentAdmin/GetBusinessStudentSelectData',
    method: 'get',
  })
}

// 学生登录记录详情列表
export function GetStudentLoginRecordList(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/LoginRecordAdmin/GetStudentLoginRecordList',
    method: 'get',
    params: {
      StudentId: obj.StudentId,
      StartTime: obj.StartTime,
      EndTime: obj.EndTime,
      PageIndex: obj.PageIndex,
      PageSize: obj.PageSize,
    }
  })
}
// 批量修改学员所属招生老师(业务员)
export function updateStudentBusiness(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdateStudentBusiness',
    method: 'post',
    data: {
      studentIds: obj.studentIds,
      businessId: obj.businessId
    }
  })
}

// 批量修改学员所属来源渠道
export function updateStudentSourse(data) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdateStudentSourse',
    method: 'post',
    data: data
  })
}

// 统计指定学员订单总缴费金额与总退费金额:只针对包含课程产品的订单
export function upPayRecord(ids) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/PayRecord',
    method: 'post',
    data: ids
  })
}
// 批量修改指定学员的缴费退费金额及当前状态:更新当前状态学员的缴费金额必须大于配置中心报名课程缴费金额下限要求
export function UpdateStudentMoneyAndState(data) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/UpdateStudentMoneyAndState',
    method: 'post',
    data: data
  })
}
// 批量修改学员所属用户运营老师
export function UpdateStudentOperation(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/UpdateStudentOperation',
    method: 'post',
    data: {
      studentIds: obj.studentIds,
      operationId: obj.operationId
    }
  })
}
// 批量用户运营批量分配招生老师
export function AssignEnrollmentTeachers(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/AssignEnrollmentTeachers',
    method: 'post',
    data: {
      studentIds: obj.studentIds,
      businessId: obj.businessId
    }
  })
}
// 批量更新学员微信id
export function UpdateStudentWechatId(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/UpdateStudentWechatId',
    method: 'post',
    data: obj
  })
}
// /TZsbAdminStudentApi/StudentAdmin/GetRecommendStudentList
export function GetRecommendStudentList(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdmin/GetRecommendStudentList',
    method: 'post',
    data: {
      name: obj.Name,
      selectStudentIds: obj.SelectStudentIds,
      total: obj.Total,
      handoverId: obj.handoverId,
      businessId: obj.businessId
    }
  })
}
// 合并学员初始化接口
export function GetMergeStudentBaseInfo() {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetMergeStudentBaseInfo',
    method: 'get',
  })
}
// 获取需要合并的学员数据
export function GetStudentData(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/GetStudentData',
    method: 'get',
    params: {
      oldStudentId: obj.oldStudentId,
      newStudentId: obj.newStudentId
    }
  })
}
// 合并学员数据
// export function MergeStudentData(obj) {
//   return request2({
//     url: '/api2/TZsbAdminStudentApi/StudentAdminV2/MergeStudentData',
//     method: 'post',
//     data: {
//       oldStudentId: obj.oldStudentId,
//       newStudentId: obj.newStudentId,
//       dataItemList: obj.dataItemList
//     }
//   })
// }

// TZsbAdminFocuseApi/Orders/GetIntroducePayRecords 学员报名课程班级列表
export function GetIntroducePayRecords(obj) {
  return request2({
    url: '/api2/TZsbAdminFocuseApi/Orders/GetIntroducePayRecords',
    method: 'get',
    params: obj
  })
}
// 获取审批状态类型
export function GetApproveStateList(obj) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/Orders/GetApproveStateList',
    method: 'get',
    params: obj
  })
}
// 获取审批推荐状态类型
export function GetApproveIntroduceStateList(obj) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/Orders/GetApproveIntroduceStateList',
    method: 'get',
    params: obj
  })
}
// 审批推荐状态
export function ApproveIntroduceState(obj) {
  return request2({
    url: '/api2/TZsbAdminOrderApi/PayRecord/ApproveIntroduceState',
    method: 'post',
    data: obj
  })
}
// 批量更新学员微信id
export function DelWechatId(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/DelWechatId',
    method: 'post',
    data: obj
  })
}
//修改学员状态
export function updateStudentState(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/UpdateStudentState',
    method: 'post',
    params: obj
  })
}
// 获取待合并学员列表
export function GetTobeMergeStudentList(obj) {
  return request2({
    url: `/api2/TZsbAdminStudentApi/StudentAdminV2/GetTobeMergeStudentList`,
    method: 'get',
    params: obj
  })
}
// 获取默认的主账号
export function GetMasterAccount(obj) {
  let length2 = obj.idList?.length || 0
  let idList = ''
  for (let i = 0; i < length2; i++) {
    if (i == length2 - 1) {
      idList += `ids=${obj.idList[i]}`
    } else {
      idList += `ids=${obj.idList[i]}&`
    }
  }
  console.log(obj,idList,'idList')
  return request2({
    url: `/api2/TZsbAdminStudentApi/StudentAdminV2/GetMasterAccount?${idList}`,
    method: 'get',
  })
}
// 合并学员
export function MergeStudentData(obj) {
  return request2({
    url: '/api2/TZsbAdminStudentApi/StudentAdminV2/MergeStudentData',
    method: 'post',
    data: {
      name: obj.obj.name,
      telNumber: obj.obj.telNumber,
      weiXinNumber: obj.obj.weiXinNumber,
      weChatId: obj.obj.weChatId,
      idCardNumber: obj.obj.idCardNumber,
      candidateCategory: obj.obj.candidateCategory,
      admissionYear: obj.obj.admissionYear,
      graduationInstitute: obj.obj.graduationInstitute,
      graduationMajor: obj.obj.graduationMajor,
      remarks: obj.obj.remarks,
      orders: obj.obj.orders,
      studentId: obj.studentId,
      masterStudentId: obj.masterStudentId,
    }
  })
}

// 获取默认的主账号
export function GetSignUpStudentList(obj) {
  let length2 = obj.CategoryIds?.length || 0
  let idList = ''
  for (let i = 0; i < length2; i++) {
    if (i == length2 - 1) {
      idList += `CategoryIds=${obj.CategoryIds[i]}`
    } else {
      idList += `CategoryIds=${obj.CategoryIds[i]}&`
    }
  }
  let params = JSON.parse(JSON.stringify(obj))
  delete params.CategoryIds
  return request2({
    url: `/api2/TZsbAdminFocuseApi/Student/GetSignUpStudentList?${idList}`,
    method: 'get',
    params: params
  })
}
